import { renderAccordionItem_unstable } from '@fluentui/react-accordion';

/**
 * Renders the final JSX of the AccordionItem component, given the state and context values.
 */
export const renderAccordionItem = renderAccordionItem_unstable;
